export { default } from './ShelfBottomControls';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfBottomControls/index.js